var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page"},[_c('div',{staticClass:"p-5"},[(_vm.error)?_c('BError',[_vm._v(_vm._s(_vm._f("translate")(['oktaUnauthorized', 'featureUnauthorized', 'featureUnauthorizedNoRedirect', 'noRegionsError', 'regionsError'].find(e=>e === _vm.error),_vm.labels,'shared_CommonErrors'))+" "+_vm._s(_vm.message))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }